module.exports = __webpack_public_path__ + "img/blue.1d8b11c2.png";